export default __webpack_public_path__ + "static/media/img_team_manager-3.01aac078.png";